import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { AdditionalInfo, Button } from 'src/Components'

import styles from './Step.module.scss'

const CMASectionImprovements = ({ setAnswer, goTo }) => {
  const handleAnswer = (answer, step) => () => {
    setAnswer({ question: 'homeUpdated', answer }, step)
  }

  return (
    <Fragment>
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='Homeowner.cmaWizard.improvements.headline'
          defaultMessage='Have you made any improvements to your home since you purchased it?'
        />
      </AdditionalInfo.Heading>
      <Button.Group className={styles.buttonGroup}>
        <Button onClick={handleAnswer(true)}>
          <FormattedMessage
            id='Homeowner.cmaWizard.improvements.improvementsButton'
            defaultMessage='Yes'
          />
        </Button>
        <Button onClick={handleAnswer(false, 'homeFacts')}>
          <FormattedMessage
            id='Homeowner.cmaWizard.improvements.noImprovementsButton'
            defaultMessage='No'
          />
        </Button>
      </Button.Group>
    </Fragment>
  )
}

export default CMASectionImprovements
